import timezoneOptions from '../options/timezone';
import momentTimezone from 'moment-timezone';

import moment from 'moment';


const getTimeAbbr = () => {
  return momentTimezone().tz(momentTimezone.tz.guess()).zoneAbbr()
}

const phase1StartDate = moment().add(5, 'minutes')

const phase1Fields = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Campaign Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  date_from: {
    value: phase1StartDate.format('MM/DD/YY'),
    error: null,
    name: 'date_from',
    placeholder: 'Date From',
    breed: 'date',
    touched: true,
    isRequired: true,
    validationType: 'isNotInPast',
    hasBlurred: false,
    inputType: 'text',
  },
  start_time: {
    value: phase1StartDate,
    error: null,
    name: 'start_time',
    placeholder: 'Start Time (' + getTimeAbbr() + ')',
    breed: 'time',
    touched: false,
    isRequired: true,
    validationType: 'isNotInPast',
    hasBlurred: false,
    inputType: 'text',
  },
  is_coupon: {
    value: true,
    error: null,
    name: 'is_coupon',
    placeholder: 'Include a digital coupon',
    breed: 'checkbox',
    touched: false,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'checkbox',
    extraClass: 'checkbox__left',
  },
  // is_offer: {
  //   value: false,
  //   error: null,
  //   name: 'is_offer',
  //   placeholder: 'Require Customers to Claim Offer',
  //   breed: 'checkbox',
  //   touched: false,
  //   isRequired: false,
  //   validationType: null,
  //   hasBlurred: false,
  //   inputType: 'checkbox',
  //   extraClass: 'checkbox__left',
  //   depends_on: 'is_coupon'
  // },
  body: {
    value: '',
    error: null,
    name: 'body',
    placeholder: 'Body',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: 'length',
    hasBlurred: false,
    inputType: 'textarea',
    charLimit: 160,
  },
  // campaign_type: {
  //   value: '',
  //   error: null,
  //   name: 'timezone',
  //   placeholder: 'Select Time Zone',
  //   breed: 'select',
  //   touched: false,
  //   isRequired: true,
  //   validationType: null,
  //   hasBlurred: false,
  //   inputType: 'text',
  // 	options: timezoneOptions
  // },
};

export default phase1Fields;



/** WEBPACK FOOTER **
 ** ./src/forms/campaign/createPhase1.js
 **/